/*
Sohel 01/02/2022 2789725780 search Table Changes
Sohel 01/03/2022 2789725780 reset Basic Info Data
Sohel 01/06/2022 3075154998 added condition on For API call in Table
dilip 01/09/2023 3075154998 Added search data local storage
Sohel 01/10/2023 2699299906 Implemented Copy Functionality
Sohel 01/11/2023 2699299906 implement System notes functionality
Sohel 01/12/2023 2699299906 Added download configuration
Sohel 01/12/2023 2699299906 isDraft Changes
manikanta 01/12/2023 2699299906,3075154998 fixed delete popup message
manikanta 01/12/2023 2699299906,3075154998 Converting data into UpperCase
Lalitha 01/13/2023 2699391155, 2699299906 fixed sorting issue for createdDate
Akhila 01/16/2023 2699391155 Disable Download configuration button when there is no table Data
sai krishna 01/16/2023 2699391155 renamed the popup heading
Lalitha  01/17/2023 2699391155 renamed delete the popup heading
Sohel 01/18/2023 3075154998 fixed reset Issue
Sohel 01/18/2023 3075154998 Download Configuration Payload Changes
Sohel 01/18/2023 2698951347 Fixed Status  issue
sai krishna 01/20/2023 2698951347 renamed notes tooltip
Sohel 01/20/2023 2698951347 Fixed page break issue
Sohel 01/20/2023 2698951347 Download Configuration Payload Changes
Sohel 01/22/2023 2698951347 Added Last Step
Sohel 01/23/2023 2698951347 fixed length populate issue
Ashraf 01/27/2023 2698951347 added new columns category and audit
kavyareddy 01/30/2023 2698951347 Integrated category,audit, payload
Sohel 01/31/2023 2698951347 label changes
Dilip 01/31/2023 2698951347 label and title changes
sai krishna 01/16/2023 2698951347  updated download configuration payload
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Sohel 01/08/2023 2698951347 removed duplicate Delete button
Rohini 02/09/2023 2698951347 added classnames for buttons
Ravi 02/09/2023 2698951347 Added used in Usage Toast Messege
Dilip 02/09/2023 2701335619 added creted for and creted by columns and payload changes
Akhila 02/24/2023 2701335619 implemented preview file functionality in download configuration
Sohel 02/24/2023 2698964415 usage popup title changes
Sohel 02/24/2023 2698964415 Download Configuration Payload Changes
Dilip 02/27/2023 2701335619 Fixed Sorting issue
Ravi 03/01/2023 2701335619 Added loader and download toast message for preview File
T Santosh Kumar 15/03/2023 2698964415 Responsive UI Changes
Raghu 03/15/2023 2698964415 fixed table action
Raghu 03/16/2023 2698964415 fixed table action
Raghu 03/04/2023 2698964415 added plus icon
Akhila 05/04/2023 2698964415 Added update date column and in payload
Ravi 05/31/2023 2698964415  changed delete popup message
Akhila 06/06/2023 2698964415 added code and description in action
Akhila 06/08/2023 2698964415 title label placeholder name change
Akhila 06/08/2023 2698964415 rearrange the column and form fields
Akhila 06/12/2023 2698964415 added role access
*/
import React, {createRef, useState, useEffect, useRef} from 'react';
import {TablePagination, Grid, Button, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import moment from 'moment';
import {httpGet, httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchBasicInfoData,
  fetchDataManagerRecordGroupUsage,
  postPrintImportRecordGroup,
  resetBasicInfo,
  resetBasicInfoRecordGroup,
  resetDataManagerRecordGroup,
  resetDataManagerRecordGroupUsage,
  setFixedLengthRedux,
  setIsDraftRecordGroup,
  setLastStepRecordGroupRedux,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import {useUpdateEffect} from 'react-use';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import DialogBox from '../../../../../components/DialogBox';
import CopyRecordGroup from '../../ImportManagerRecordGroup/SearchImportMRGroup/CopyRecordGroup';
import ExportManagerRecordGroupNotes from '../../ImportManagerRecordGroup/SearchImportMRGroup/ImportManagerRecordGroupNotes';
import {resetDataManagerRecord} from '../../../../../redux/reducers/DataManagerRecord';
import UsageMessage from '../../../../../util/UsageMessage';
import OverrideRule from '../../../../../components/OverrideRule';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import PageLoader from '../../../../../components/PageLoader';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {downloadButton} from '../../../../../util/Content';
import axios from 'axios';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
function SearchIMRTable({
  setValue,
  searchData,
  submit,
  setSubmit,
  setDataManagerRecordGroupData = () => {},
  exportRecordGroupAccess,
  setEditExisting,
}) {
  const tableRef = createRef();
  const queryRef = useRef(null);
  const classes1 = useStyles();
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [rows, setRows] = useState(defaultRows);
  const deletedId = useRef('');
  const [oldGroupCodeData, setOldGroupCodeData] = useState({});
  const [copyRecordGroup, setCopyRecordGroup] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [recordGroupCode, setRecordGroupCode] = useState('');
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const {
    successMsg,
    errorMsg,
    addBasicInfoStatus,
    isLoading,
    dataManagerRecordGroupUsage,
    configurationUrl,
    dockey,
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const [arrayLast, setArrayLast] = useState(false);
  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };
  const [resultCount, setResultCount] = useState(0);
  const onEditCall = (rowData) => {
    dispatch(
      setIsDraftRecordGroup({
        property: 'isDraftRecordGroup',
        value: rowData?.isDraft,
      }),
    );
    dispatch(
      setLastStepRecordGroupRedux({
        property: 'lastStep',
        value: rowData?.lastStep,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: rowData?.fixedLength,
      }),
    );
  };

  const [loading, setIsLoadingDelete] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const columns = [
    {
      title: 'Category',
      field: 'category',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
          'CL - Client' :
          rowData?.category === 'CO' ?
            'CO - Core' :
            rowData?.category === 'PA' ?
              'PA - Payment' :
              '';
      },
    },
    {
      title: 'Export Record Group Name',
      field: 'groupCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            setEditExisting('Export Record Group');
            onEditCall(rowData);
            dispatch(fetchBasicInfoData(rowData?.dmRecordGroupId));
            setValue(1);
          }}
        >
          {rowData?.groupCode?.replace(/ /g, '\u00a0')}
        </span>
      ),
    },
    {
      title: 'Export Record Group Description',
      field: 'groupDescription',
      render: (rowData) => rowData?.groupDescription?.replace(/ /g, '\u00a0')
    },
    {
      title: 'Record Group Type',
      field: 'groupType',
    },
    {
      title: 'Include Audit',
      field: 'includeAudit',
      render: (rowData) =>
        rowData?.includeAudit === 'Y' ? 'Y - Yes' : rowData?.includeAudit === 'N' ? 'N - No' : '',
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDt',
      render: (rowData) => {
        return rowData?.createdDt ? moment(rowData?.createdDt).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Updated Date',
      field: 'updatedDate',
      render: (rowData) => {
        return rowData?.updatedDate ?
          moment(rowData?.updatedDate).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const handleEdit = (rowData) => {
    setEditExisting('Export Record Group');
    onEditCall(rowData);
    dispatch(fetchBasicInfoData(rowData?.dmRecordGroupId));
    setValue(1);
  };
  const handleCopy = (rowData) => {
    setOldGroupCodeData(rowData);
    setCopyRecordGroup(true);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setRecordGroupCode(rowData);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setDataManagerRecordGroupData(rowData);
    dispatch(fetchDataManagerRecordGroupUsage('Export', rowData.dmRecordGroupId));
  };
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const handleDelete = (rowData) => {
    dispatch(fetchDataManagerRecordGroupUsage('Export', rowData.dmRecordGroupId));
    setIsDelete(false);
    setDeleteUsage(true);
    deletedId.current = rowData;
  };
  useEffect(() => {
    dispatch(resetDataManagerRecordGroup());
    dispatch(resetBasicInfoRecordGroup());
    dispatch(resetDataManagerRecord());
    dispatch(
      setIsDraftRecordGroup({
        property: 'isDraftRecordGroup',
        value: '',
      }),
    );
    dispatch(
      setLastStepRecordGroupRedux({
        property: 'lastStep',
        value: 0,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: '',
      }),
    );
  }, []);

  const handleSubmit = () => {
    httpGet(`record/group/delete/${deletedId.current?.dmRecordGroupId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.message);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleCopyRecordGroup = () => {
    setCopyRecordGroup(false);
  };
  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('exportrecordgroup'));
      dispatch(fetchCreatedForDropDownData('exportrecordgroup'));
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addBasicInfoStatus === 200 && successMsg) {
      if (oldGroupCodeData?.isDraft) {
        dispatch(
          setIsDraftRecordGroup({
            property: 'isDraftRecordGroup',
            value: oldGroupCodeData?.isDraft ? oldGroupCodeData?.isDraft : '',
          }),
        );
      }
      setTimeout(() => {
        dispatch(resetBasicInfo());
        setValue(1);
      }, 1500);
    }
  }, [successMsg, addBasicInfoStatus]);

  const EMRecordGroupSessionStorage = JSON.parse(sessionStorage.getItem('EMRecordGroup'));
  if (EMRecordGroupSessionStorage && !submit) {
    searchData = EMRecordGroupSessionStorage;
  }
  useEffect(() => {
    if (dataManagerRecordGroupUsage?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetDataManagerRecordGroupUsage());
        }, 3000);
      }
    } else if (dataManagerRecordGroupUsage?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [dataManagerRecordGroupUsage]);
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Export Record Group'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={userMetrixDelete ? 'Export Record Groups Usage' : 'Delete Export Record Group'}
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Export Record Group'} />
          ) : (
            `Are you sure you want to delete the ${deletedId.current?.groupCode?.replace(/ /g, '\u00a0')} Export Record Group?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Export Record Group Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.groupCode?.replace(/ /g, '\u00a0') || ''} - ${
          deletedId.current?.groupDescription?.replace(/ /g, '\u00a0') || ''
        } Export Record Group has been used in the following Exports.`}
        data={dataManagerRecordGroupUsage?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={copyRecordGroup}
        dialogClose={handleCopyRecordGroup}
        title={`Copy Export Record Group`}
        maxWidth="md"
        hideFooter={true}
      >
        <CopyRecordGroup oldGroupCodeData={oldGroupCodeData} type={'Export'} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title="Export Record Group Notes"
        maxWidth="lg"
      >
        <ExportManagerRecordGroupNotes
          imrgData={recordGroupCode}
          type={'Export'}
          exportRecordGroupAccess={exportRecordGroupAccess}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields actions-dropdown-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `record/group/search/all`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  groupCode: searchData?.importMRGroupCode ?
                    searchData?.importMRGroupCode.toUpperCase() :
                    '',
                  groupType: searchData?.importMRGroupType?.value ?
                    searchData?.importMRGroupType?.value :
                    '',
                  groupDescription: searchData?.importMRGroupDescripton ?
                    searchData?.importMRGroupDescripton :
                    '',
                  category: searchData?.category?.categoryCode ?
                    searchData?.category?.categoryCode :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  includeAudit: searchData?.includeAudit?.key ? searchData?.includeAudit?.key : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  // orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : "",
                  orderBy:
                    query?.orderBy && query?.orderBy?.field === 'createdDt' ?
                      'createdDate' :
                      query?.orderBy?.field,
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  tabType: 'Export',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.response;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        setResultCount(response?.data?.response?.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      disabled={Boolean(resultCount === 0)}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: '',
                            description: '',
                            displayName: '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: '',
                            sourceType: 'EXPORT RECORD GROUP',
                            isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                            search: '',
                            frameworkUsageOrderBy: '',
                            frameworkUsageOrderDerection: '',
                            fieldListOrderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            fieldListOrderDerection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            category: searchData?.category?.categoryCode ?
                              searchData?.category?.categoryCode :
                              '',
                            includeAudit: searchData?.includeAudit?.key ?
                              searchData?.includeAudit?.key :
                              '',
                            fieldName: '',
                            repositoryDescription: '',
                            repositoryName: '',
                            repositoryType: '',
                            createdBy: '',
                            groupCode: searchData?.importMRGroupCode ?
                              searchData?.importMRGroupCode :
                              '',
                            groupType: searchData?.importMRGroupType?.value ?
                              searchData?.importMRGroupType?.value :
                              '',
                            groupDescription: searchData?.importMRGroupDescripton ?
                              searchData?.importMRGroupDescripton :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                          }),
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn ml-2 ${classes1.buttonRoot}`}
                      disabled={resultCount === 0}
                      onClick={() => {
                        dispatch(
                          postPrintImportRecordGroup(
                            {
                              groupCode: searchData?.importMRGroupCode ?
                                searchData?.importMRGroupCode :
                                '',
                              groupType: searchData?.importMRGroupType?.value ?
                                searchData?.importMRGroupType?.value :
                                '',
                              groupDescription: searchData?.importMRGroupDescripton ?
                                searchData?.importMRGroupDescripton :
                                '',
                              createdDate: searchData?.createdDate ?
                                moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                '',
                              orderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              orderDirection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                              isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                              tabType: 'Export',
                              category: searchData?.category?.categoryCode ?
                                searchData?.category?.categoryCode :
                                '',
                              includeAudit: searchData?.includeAudit?.key ?
                                searchData?.includeAudit?.key :
                                '',
                              createdFor: searchData?.createdFor?.userLoginName ?
                                searchData?.createdFor?.userLoginName :
                                '',
                              createdBy: searchData?.createdBy?.userLoginName ?
                                searchData?.createdBy?.userLoginName :
                                '',
                            },
                            'Export',
                          ),
                        );
                      }}
                    >
                      {downloadButton}
                    </Button>
                  </div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  // handleRun={handleRun}
                  // handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: props?.data?.repositoryType === 'SYSTEM',
                    run: true,
                    copy: false,
                    hiddenDelete: false,
                    notes: false,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !exportRecordGroupAccess?.edit,
                    disableRun: false,
                    disableCopy: !exportRecordGroupAccess?.add,
                    disableDelete: !exportRecordGroupAccess?.delete,
                    disableNotes: false,
                    disableExecution: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!exportRecordGroupAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        setValue(1);
                        dispatch(resetDataManagerRecordGroup());
                        dispatch(
                          setIsDraftRecordGroup({
                            property: 'isDraftRecordGroup',
                            value: '',
                          }),
                        );
                        dispatch(
                          setLastStepRecordGroupRedux({
                            property: 'lastStep',
                            value: 0,
                          }),
                        );
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Export Record Group
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}

            // actions={[
            //   {
            //     icon: () => (
            //       <>
            //         <Button type="button" variant="outlined" className={`search-btn`}>
            //           Add Record Group
            //         </Button>
            //       </>
            //     ),
            //     isFreeAction: true,
            //     onClick: () => {
            //       setValue(1);
            //       dispatch(resetDataManagerRecordGroup());
            //       dispatch(
            //         setIsDraftRecordGroup({
            //           property: "isDraftRecordGroup",
            //           value: "",
            //         })
            //       );
            //       dispatch(
            //         setLastStepRecordGroupRedux({
            //           property: "lastStep",
            //           value: 0,
            //         })
            //       );
            //     },
            //   },
            //   {
            //     icon: () => <EditOutlinedIcon />,
            //     tooltip: "Edit",
            //     onClick: (event, rowData) => {
            //       onEditCall(rowData);
            //       dispatch(fetchBasicInfoData(rowData?.groupCode));
            //       setValue(1);
            //     },
            //   },
            //   {
            //     icon: () => (
            //       <>
            //         <FileCopyOutlinedIcon />
            //       </>
            //     ),
            //     tooltip: "Copy",
            //     onClick: (event, rowData) => {
            //       setOldGroupCodeData(rowData);
            //       setCopyRecordGroup(true);
            //     },
            //   },
            //   {
            //     icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //     tooltip: "Usage",
            //     onClick: (event, rowData) => {
            //       setDeleteUsage(false);
            //       setDataManagerRecordGroupData(rowData);
            //       dispatch(fetchDataManagerRecordGroupUsage("Export", rowData.groupCode));
            //     },
            //   },
            //   (rowData) => {
            //     return {
            //       icon: () => (
            //         <>
            //           <DeleteOutlineOutlinedIcon />
            //         </>
            //       ),
            //       tooltip: "Delete",
            //       onClick: () => {
            //         handleDelete(rowData);
            //       },
            //     };
            //   },
            //   {
            //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //     tooltip: "Export Record Group Notes",
            //     onClick: (event, rowData) => {
            //       setIsNote(true);
            //       setRecordGroupCode(rowData?.groupCode);
            //     },
            //   },
            // ]}
          />
        </div>
      </Grid>
      {(isLoading || printUsageIsLoading || loading) && <PageLoader />}
      {(deleteErrorMsg || errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={deleteErrorMsg || errorMsg || printUsageErrorMsg} />
      )}
      {(tstmsg || successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={tstmsg || successMsg || printUsageSuccessMsg} />
      )}
      {customError && (
        <WarningSnackbar errorMsg={`This Export Record Group is not being used anywhere`} />
      )}
    </>
  );
}

export default SearchIMRTable;
